import { render, staticRenderFns } from "./TarifaSmolt.vue?vue&type=template&id=5057ac31"
import script from "./TarifaSmolt.vue?vue&type=script&lang=js"
export * from "./TarifaSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports